"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderNearby = void 0;
var React = require("react");
var MapObject_1 = require("@/pages/detail/components/MapObject");
var myokay_map2_1 = require("@okay/myokay-map2");
// export const renderNearby = (props: DetailAllProps) => {
exports.renderNearby = function (config, onMapObjectClick, onMapObjectsClick, onMarkerClick) {
    // const config = props.nearbyMap.big;
    var renderObject = function (object, i) { return MapObject_1.renderMapObject(object, i, onMapObjectClick, onMapObjectsClick, onMarkerClick); };
    return (React.createElement("div", { className: "o-googlemap", style: {
            width: '100%',
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
        } },
        React.createElement(myokay_map2_1.GoogleMap, __assign({}, config.mapState), config.objects.map(renderObject))));
};
